import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectShowDetail } from 'store/Contextualization/AssetDetail/selectors';
import Title from '../Title';
import {
  Wrapper,
  CloseIconWrapper,
  CloseIcon
} from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Header/styled';

const Header = ({ onClose }) => {
  const show = useSelector((state) => selectShowDetail('vulns', state));

  if (!show) return null;
  return (
    <Wrapper>
      <Title />
      <CloseIconWrapper onClick={ onClose }>
        <CloseIcon />
      </CloseIconWrapper>
    </Wrapper>
  );
};

Header.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Header;
